import React from "react";
import styled from "@emotion/styled";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const PreviewRoot = styled.div`
  font-size: 13px;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.85);
  word-break: break-word;

  & h1,
  & h2,
  & h3,
  & h4 {
    margin: 0.75em 0 0.35em;
    font-weight: 600;
    line-height: 1.3;
  }
  & h1 {
    font-size: 1.15em;
  }
  & h2 {
    font-size: 1.08em;
  }
  & h3,
  & h4 {
    font-size: 1em;
  }
  & p {
    margin: 0.35em 0;
  }
  & ul,
  & ol {
    margin: 0.35em 0;
    padding-left: 1.35em;
  }
  & li {
    margin: 0.2em 0;
  }
  & blockquote {
    margin: 0.5em 0;
    padding: 0.25em 0 0.25em 0.75em;
    border-left: 3px solid #d9d9d9;
    color: rgba(0, 0, 0, 0.65);
  }
  & code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.92em;
    padding: 0.1em 0.35em;
    background: #f5f5f5;
    border-radius: 3px;
  }
  & pre {
    margin: 0.5em 0;
    padding: 10px 12px;
    background: #f5f5f5;
    border-radius: 6px;
    overflow-x: auto;
    font-size: 12px;
  }
  & pre code {
    padding: 0;
    background: none;
    border-radius: 0;
  }
  & a {
    color: #1677ff;
  }
  & table {
    border-collapse: collapse;
    margin: 0.5em 0;
    width: 100%;
    font-size: 12px;
  }
  & th,
  & td {
    border: 1px solid #f0f0f0;
    padding: 6px 8px;
    text-align: left;
  }
  & th {
    background: #fafafa;
    font-weight: 600;
  }
  & hr {
    border: none;
    border-top: 1px solid #f0f0f0;
    margin: 0.75em 0;
  }
`;

interface RoadmapMarkdownPreviewProps {
  markdown: string;
  emptyLabel?: string;
}

export const RoadmapMarkdownPreview: React.FC<RoadmapMarkdownPreviewProps> = ({
  markdown,
  emptyLabel = "Nothing to preview yet.",
}) => {
  const trimmed = markdown.trim();
  if (!trimmed) {
    return (
      <PreviewRoot>
        <span style={{ color: "rgba(0,0,0,0.35)", fontStyle: "italic" }}>{emptyLabel}</span>
      </PreviewRoot>
    );
  }

  return (
    <PreviewRoot>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a(props) {
            // react-markdown injects `node`; omit from DOM spread
            const { node: _node, ...rest } = props;
            void _node;
            return <a {...rest} target="_blank" rel="noopener noreferrer" />;
          },
        }}
      >
        {markdown}
      </ReactMarkdown>
    </PreviewRoot>
  );
};
